// Klasa	          | Efekt                        | Parametry CSS Custom Properties
// .parallax-3d	    | Perspektywa 3D	             | --parallax-intensity: 2;
// .animate-stagger | Kaskadowe animacje elementów | --stagger-delay: 0.1s;
// .blur-transition | Rozmycie przy zmianie sekcji | --blur-amount: 5px;

// <div class="section four parallax parallax-3d" style="--parallax-intensity: 3;">
//     <div data-depth="0.5" class="animate-stagger" style="--stagger-delay: 0.2s;">
//         Tekst będzie się animował z opóźnieniem
//     </div>
// </div>



export function initMechanika() {

  const container = document.querySelector(".container");

  // Dynamiczne pobieranie elementów
  const sections = () => document.querySelectorAll(".section");

  // Stan aplikacji
  const appState = {
    currentSection: 0,
    horizontalStates: new Map(),
  };

  // Tymczasowe dane z myszki/palca
  const inputState = {
    isPointerDown: false,
    startX: 0,
    startY: 0,
  };

  // Techniczne flagi i konfiguracja
  const scrollControl = {
    isScrolling: false,
    lastSectionDirection: 1,
    threshold: 30,
    lastScrollTime: 0, // ← zmienna dla blokowania scrolla wielokrotnego na trackpadzie 
  };

  // Poczekaj ~1sek a potem wywołaj funkcję resolve
  const wait = (delay = 700) => new Promise(resolve => setTimeout(resolve, delay));
  // function wait(delay = 700) {
  //   return new Promise(resolve => setTimeout(resolve, delay));
  // }






  /**
  * Funkcje liczy ilość sekcji
  **/
  function getTotalSections() {
    return sections().length;
  }


  /**
  * Podswietlenie aktywnej sekcji
  **/
  // Funkcja aktualizuje menu nawigacyjne, podświetlając aktualnie 
  // aktywną sekcję. Dodaje lub usuwa klasę .active
  function updateMenu() {
    const currentSection = sections()[appState.currentSection];
    document.querySelectorAll('.menu a').forEach(link => {

      const rawHref = link.getAttribute('href'); // np. "#section2:2"
      // Zabezpiecznie dla linków z klasycznymi adresami
      if (!rawHref) return;
        if (rawHref.startsWith('http://') || rawHref.startsWith('https://') || rawHref.includes('//')) {
        return;
      }

      const href = decodeURIComponent(rawHref);
      const parts = href.split(':'); // Rozdziel po ":"
      const targetId = parts[0]; // "#section2"
      const targetSection = document.querySelector(targetId);

      // Bezpośrednie porównanie elementów DOM
      link.classList.toggle('active', targetSection === currentSection);
    });
  }


  /**
  * Menu podsekcji 
  **/
  // Funkcja aktualizuje menu podsekcji, podświetlających aktualnie 
  // aktywną (widoczną) subsekcję. Dodaje lub usuwa klasę .active
  function updateSubsectionMenu() {
      // 1. Znajdź aktualnie wyświetlaną sekcję
      const currentSectionElement = sections()[appState.currentSection];
      if (!currentSectionElement) return;
      // 2. Znajdź menu podsekcji wewnątrz tej sekcji
      const subsectionMenu = currentSectionElement.querySelector('.subsection-menu');
      // 3. Jeśli nie ma takiego menu, zakończ działanie funkcji
      if (!subsectionMenu) {
          // Dodatkowo, jeśli w innej sekcji było aktywne menu, możemy je wyczyścić.
          // To na wszelki wypadek, gdybyś dodał więcej takich menu w przyszłości.
          document.querySelectorAll('.subsection-menu a.active').forEach(link => link.classList.remove('active'));
          return;
      }
      // 4. Pobierz aktualny stan horyzontalny dla tej sekcji
      const horizontalState = getCurrentHorizontalState();
      if (!horizontalState) return; // Jeśli z jakiegoś powodu stan nie istnieje
      // 5. Pobierz indeks aktywnej podsekcji
      const activeSubsectionIndex = horizontalState.currentSubsection;
      // Najpierw usuń wszystkie poprzednie klasy 'submenu-*', aby uniknąć ich kumulacji.
      // Używamy pętli, bo element może mieć inne klasy, których nie chcemy ruszać.
      for (const cls of Array.from(subsectionMenu.classList)) {
          if (cls.startsWith('submenu-')) {
              subsectionMenu.classList.remove(cls);
          }
      }
      // Następnie dodaj nową, aktualną klasę. Używamy indeksu + 1, żeby było czytelniej.
      // Twój pierwszy slajd ma indeks 0, więc dostanie klasę 'submenu-1'.
      subsectionMenu.classList.add(`submenu-${activeSubsectionIndex + 1}`);

      // 6. Przejdź przez wszystkie linki w menu podsekcji
      const links = subsectionMenu.querySelectorAll('a');
      links.forEach(link => {
          const rawHref = link.getAttribute('href'); // np. "#section3:2"
          const href = decodeURIComponent(rawHref); // <-- to dekoduje %3A na :
          const parts = href.split(':');
          // Domyślnie zakładamy, że link nie ma określonej podsekcji (np. href="#section3")
          // co mogłoby oznaczać podsekcję 0. W Twoim przypadku zawsze jest indeks.
          let linkTargetIndex = null;
          if (parts.length > 1) {
              linkTargetIndex = parseInt(parts[1], 10);
          }
          // Porównaj indeks z linku z aktywnym indeksem w stanie aplikacji
          // i odpowiednio przełącz klasę 'active'
          const isActive = linkTargetIndex === activeSubsectionIndex;
          link.classList.toggle('active', isActive);
      });
  }


/**
  * Wymiary i stan dla sekcji poziomych przed ich użyciem
  **/
  // Funkcja oblicza szerokość kontenerów (.horizontal-wrapper) 
  // na podstawie liczby podsekcji oraz ustawia początkowy stan 
  // widoczności – czyli która podsekcja jest aktywna przy starcie.
  //
  function initDimensions() {
    sections().forEach((section, index) => {
      if (section.classList.contains("horizontal")) {
          const wrapper = section.querySelector(".horizontal-wrapper");
          const subsections = wrapper.querySelectorAll(".subsection");
          wrapper.style.width = `${subsections.length * 100}vw`;
          
          appState.horizontalStates.set(index, {
              currentSubsection: 0,
              totalSubsections: subsections.length
          });
      }
    });
  }


/**
  * Określa stan aktualnej sekcji poziomej
  **/
  // Funkcja zwraca stan podsekcji bieżącej sekcji poziomej, podając indeks 
  // aktualnie widocznej podsekcji oraz całkowitą liczbę podsekcji w kontenerze.
  function getCurrentHorizontalState() {
    const sectionIndex = appState.currentSection;
    const section = sections()[sectionIndex];
    return section?.classList.contains("horizontal") 
        ? appState.horizontalStates.get(sectionIndex)
        : null;
  }


/**
  * Przesuwanie między sekcjami pionowymi
  **/
  // Funkcja przesuwa widok w górę lub w dół, dodając i usuwając klasy sygnalizujące proces przewijania. 
  // Aktualizuje menu, podświetlając aktualną pozycję w menu głównym  i w menu podsekcji.
  // Ustawia stan podsekcji w sekcjach poziomych:
  //    - przy przewijaniu w dół ustawia aktywną ostatnią podsekcję,
  //    - przy przewijaniu w górę ustawia aktywną pierwszą podsekcję.
  // Obsługuje również sekcje `sticky-section`, czyli wprowadza opóźnienie dla sekcji "przyklejonych".
  async function navigateSection(direction) {
    const newIndex = appState.currentSection + direction;
    if (newIndex < 0 || newIndex >= getTotalSections()) return;

    const currentSection = sections()[appState.currentSection];
    const newSection = sections()[newIndex];

    scrollControl.isScrolling = true;
    scrollControl.lastSectionDirection = direction;

    if (currentSection.classList.contains("sticky-section") && direction === 1) {
        await handleStickyScroll(currentSection);
    }

    currentSection.classList.add('animate-out', 'slide-up');
    
    const currentHorizontal = getCurrentHorizontalState();
    if (currentHorizontal) {
        currentHorizontal.currentSubsection = direction === 1 
            ? currentHorizontal.totalSubsections - 1 
            : 0;
    }

    appState.currentSection = newIndex;
    container.style.transform = `translateY(-${newIndex * 100}vh)`;
    
    newSection.classList.add('animate-in', 'zoom-in');

    const newHorizontal = getCurrentHorizontalState();
    if (newHorizontal) {
        const wrapper = sections()[newIndex].querySelector(".horizontal-wrapper");
        wrapper.style.transform = `translateX(-${newHorizontal.currentSubsection * 100}vw)`;
    }

    await wait(700);
    

    currentSection.classList.remove('animate-out', 'slide-up');
    newSection.classList.remove('animate-in', 'zoom-in');
    
    scrollControl.isScrolling = false;
    updateMenu(); // Aktualizacja menu po zmianie sekcji
    updateSubsectionMenu();
  }


/**
  * Mierzenie postępu przewijania sekcji (sticky-section)
  **/
  // Funkcja mierzy postęp przewijania sekcji sticky i zapisuje go w zmiennej CSS --scroll-progress, 
  // przypisując wartości z przedziału pomiędzy 0 do 1. 
  // Umożliwia to sterowanie animacjami lub efektami w zależności od stopnia przewinięcia rolki myszki.
  function handleStickySectionScroll() {
    const stickySection = document.querySelector('.sticky-section');
    if (!stickySection) return;

    const stickyContent = stickySection.querySelector('.sticky-content');
    const sectionTop = stickySection.getBoundingClientRect().top;
    const sectionHeight = stickyContent.offsetHeight - stickySection.offsetHeight;

    let progress;
    // Sprawdź, czy sticky-section jest w widoku
    if (sectionTop <= 0 && Math.abs(sectionTop) <= sectionHeight) {
        // Oblicz postęp przewijania
        progress = Math.min(Math.max(Math.abs(sectionTop) / sectionHeight, 0), 1);
    } else {
        // Jeśli poza zakresem, ustaw progress na 0 lub 1
        progress = sectionTop > 0 ? 0 : 1;
    }

    stickySection.style.setProperty('--scroll-progress', progress);
    // console.log(`Scroll progress: ${progress}`);
  }


/**
  * Blokowanie przewijania sekcji sticky (sticky-section)
  **/
  // Funkcja monitoruje scroll wewnątrz `.sticky-content` i sprawdza, jak daleko
  // użytkownik przewinął zawartość.
  // - Gdy przewinie do końca sticky-content, aplikacja wie, że można przejść
  //   do następnej sekcji.
  // - Gdy przewinie do początku, aplikacja wie, że można wrócić do poprzedniej sekcji.
  // - W trakcie przewijania zapisuje postęp w atrybucie data-progress w %
  async function handleStickyScroll(section) {
      return new Promise((resolve) => {
          const stickyContent = section.querySelector(".sticky-content"); // Znajdź sticky-content
          if (!stickyContent) {
              console.error("Brak .sticky-content w sekcji!");
              resolve(0);
              return;
          }

          const maxScroll = stickyContent.scrollHeight - stickyContent.clientHeight; // Maksymalne przewinięcie

          let progress = 0;

          const onScroll = () => {
              const scrollTop = stickyContent.scrollTop; // Ile przewinięto sticky-content
              progress = Math.min(100, Math.max(0, (scrollTop / maxScroll) * 100));
              section.setAttribute("data-progress", `${Math.floor(progress)}%`);

              console.log("Progress:", progress);

              if (progress >= 100) {
                  stickyContent.removeEventListener("scroll", onScroll);
                  resolve(1); // Przejście do kolejnej sekcji
              }

              if (progress <= 0) {
                  stickyContent.removeEventListener("scroll", onScroll);
                  resolve(-1); // Powrót do poprzedniej sekcji
              }
          };

          stickyContent.addEventListener("scroll", onScroll);
          onScroll(); // Sprawdź od razu
      });
  }


/**
  * Nawigacja pozioma subsekcji
  **/
  // Funkcja przesuwa widok w lewo lub w prawo. Aktualizuje indeks 
  // bieżącej podsekcji, odtwarza dźwięk `rollover` i aktualizuje 
  // menu podsekcji.
  async function navigateSubsection(direction) {
      const horizontal = getCurrentHorizontalState();
      if (!horizontal) return;

      const newIndex = horizontal.currentSubsection + direction;
      if (newIndex < 0 || newIndex >= horizontal.totalSubsections) return;

      scrollControl.isScrolling = true;
      horizontal.currentSubsection = newIndex;
      
      const wrapper = sections()[appState.currentSection].querySelector(".horizontal-wrapper");
      wrapper.style.transform = `translateX(-${newIndex * 100}vw)`;
      // dziwęk
      const smashRollover = document.getElementById('sound-rollover');
      smashRollover?.play().catch(() => {});

      await wait();
      scrollControl.isScrolling = false;
      updateSubsectionMenu();
  }


/**
  * Nawigacja między sekcjami
  **/
  // Funkcja jest głównym mechanizmem nawigacji w aplikacji. 
  // Decyduje, co przesunąć w zależności od stanu aplikacji i kierunku:
  // - Jeśli sekcja jest pozioma, przesuwa podsekcję lub całą sekcję pionową, 
  //   jeśli osiągnięto pierwszą lub ostatnią podsekcję.
  // - Jeśli sekcja jest typu sticky, blokuje przewijanie, dopóki nie 
  //   przewiniemy całej zawartości.
  // - Jeśli zwykła sekcja pionowa, przesuwa ją w górę lub w dół.
  // Funkcja aktualizuje menu główne i menu podsekcji oraz steruje 
  // animacjami przewijania.
  function autoNavigate(direction) {
    if (scrollControl.isScrolling) return;

    const currentSection = sections()[appState.currentSection];
    const horizontal = getCurrentHorizontalState();

    // Sprawdź czy aktualna sekcja jest "sticky" i czy można ją opuścić
    if (currentSection.classList.contains("sticky-section")) {
        const stickyContent = currentSection.querySelector(".sticky-content");
        if (stickyContent) {
            const isAtTop = stickyContent.scrollTop === 0;
            const isAtBottom = stickyContent.scrollTop + stickyContent.clientHeight >= stickyContent.scrollHeight - 1;

            // Blokuj nawigację jeśli nie osiągnięto odpowiedniego progu
            if (direction === 1 && !isAtBottom) return;
            if (direction === -1 && !isAtTop) return;
        }
    }

    if (horizontal) {
        const isFirstSub = horizontal.currentSubsection === 0;
        const isLastSub = horizontal.currentSubsection === horizontal.totalSubsections - 1;
        direction === 1 
            ? (isLastSub ? navigateSection(1) : navigateSubsection(1))
            : (isFirstSub ? navigateSection(-1) : navigateSubsection(-1));
    } else {
      navigateSection(direction);
    }
  }


/**
  * Sterowanie zmianami sekcji
  **/
  // Zestaw funkcji pozwalających użytkownikowi poruszać się po stronach 
  // za pomocą myszki, touchpada, klawiatury lub palca na ekranie.  
  // Przesuwa widok w górę, w dół lub na boki. Dba o płynność ruchu, 
  // blokując kolejne przewinięcia podczas animacji i reagując tylko na 
  // ruchy wystarczająco duże, aby uznać je za zamiar przewinięcia.
  function handleScroll(e) {
      // Throttling scrolla 
      // ograniczenie bardzo dużych wartości deltaY dla trackpadów 
      // które przewijały wiele sekcji na raz
      const now = Date.now();
      const intensity = Math.abs(e.deltaY);
      const adaptiveCooldown = Math.min(1500, 300 + intensity * 2); // np. 300–1500ms

      if (now - scrollControl.lastScrollTime < adaptiveCooldown) return;
      if (intensity < 30) return;

        // Oryginalna obsługa handleScroll(e)
        const direction = e.deltaY > 0 ? 1 : -1;
        autoNavigate(direction);

      scrollControl.lastScrollTime = now;
  }
  function handleKeys(e) {
      const keyActions = {
          ArrowDown: () => autoNavigate(1),
          ArrowUp: () => autoNavigate(-1),
          ArrowRight: () => {
              const horizontal = getCurrentHorizontalState();
              if (horizontal) navigateSubsection(1);
          },
          ArrowLeft: () => {
              const horizontal = getCurrentHorizontalState();
              if (horizontal) navigateSubsection(-1);
          }
      };
      keyActions[e.key]?.();
  }
  function handlePointerStart(e) {
      if (scrollControl.isScrolling) return;
      
      const coords = e.touches ? e.touches[0] : e;
      inputState.startX = coords.clientX;
      inputState.startY = coords.clientY;
      inputState.isPointerDown = true;
  }
  function handlePointerMove(e) {
      if (!inputState.isPointerDown) return;
      e.preventDefault();
  }
  function handlePointerEnd(e) {
      if (!inputState.isPointerDown || scrollControl.isScrolling) return;
      inputState.isPointerDown = false;

      const coords = e.changedTouches ? e.changedTouches[0] : e;
      const deltaX = coords.clientX - inputState.startX;
      const deltaY = coords.clientY - inputState.startY;

      if (Math.abs(deltaX) + Math.abs(deltaY) < scrollControl.threshold) return;

      if (Math.abs(deltaX) > Math.abs(deltaY)) {
          const horizontal = getCurrentHorizontalState();
          if (horizontal) {
              const direction = deltaX > 0 ? -1 : 1;
              navigateSubsection(direction);
          }
      } else {
          const direction = deltaY > 0 ? -1 : 1;
          autoNavigate(direction);
      }
  }


/**
  * Efekt paralaksy dla elementów w sekcjach z klasą `.parallax`.
  **/
  // Każda sekcja `.parallax` może zawierać elementy z atrybutem `data-depth`.
  // `data-depth` określa siłę przesunięcia elementu w reakcji na scroll:
  //    - np. 0.2 → element przesuwa się wolniej niż scroll
  //    - np. 1   → element porusza się równomiernie ze scrollowaniem
  // Funkcja oblicza offset w osi Y dla każdego elementu:
  //    offset = (scrollPos - sectionTop) * depth * 0.5
  // Offset jest przypisywany przez CSS transform: translateY(offset)
  //
  // Optymalizacja:
  // Scroll jest throttlowany przez requestAnimationFrame i flagę `isTicking`, 
  // co zapobiega nadmiernym obliczeniom i zwiększa wydajność.
  //
  // Przykład:
  // <section class="parallax">
  //   <img src="bg.png" data-depth="0.1">
  //   <img src="midground.png" data-depth="0.5">
  //   <img src="foreground.png" data-depth="1">
  // </section>
  function initParallax() {
    let isTicking = false;
    
    const update = () => {
        document.querySelectorAll('.parallax').forEach(section => {
            const elements = section.querySelectorAll('[data-depth]');
            const scrollPos = window.pageYOffset;
            const sectionTop = section.offsetTop;
            
            elements.forEach(el => {
                const depth = parseFloat(el.dataset.depth);
                const offset = (scrollPos - sectionTop) * depth * 0.5;
                el.style.transform = `translateY(${offset}px)`;
            });
        });
        isTicking = false;
    };

    window.addEventListener('scroll', () => {
        if (!isTicking) {
            requestAnimationFrame(update);
            isTicking = true;
        }
    });
  }


/**
  * Aanimacja pzypieta oparty na postępie przewijania sekcji.
  **/
  // Obserwuje zmiany atrybutu `data-progress` w zadanych sekcjach (triggerach).
  // Dla każdej sekcji można określić wiele "warstw" (targets), które aktywują się niezależnie.
  // Każda warstwa ma własne progi procentowe:
  //   - activateAt: procent przewinięcia, przy którym dodawana jest klasa `.active`
  //   - resetAt: procent przewinięcia, przy którym klasa `.active` jest usuwana
  // Animacja aktywuje się tylko raz na cykl przewijania i resetuje po powrocie scrolla poniżej resetAt.
  //
  // Konfiguracja:
  // - configs: tablica obiektów opisujących sekcje i ich warstwy:
  //       [
  //           {
  //               trigger: '.three',        // selektor sekcji obserwowanej
  //               targets: [
  //                   { selector: '.layer1', activateAt: 20, resetAt: 5 },
  //                   { selector: '.layer2', activateAt: 50, resetAt: 10 },
  //                   { selector: '.layer3', activateAt: 80, resetAt: 30 },
  //               ]
  //           },
  //       ]
  //
  // Zasady działania:
  // 1. Każda sekcja obserwowana jest przez MutationObserver, który reaguje na zmianę data-progress.
  // 2. Każda warstwa w sekcji posiada własny stan (`isActive`, `previousProgress`).
  // 3. Po przekroczeniu activateAt → dodanie klasy `.active`.
  // 4. Po powrocie poniżej resetAt → usunięcie klasy `.active`.
  // 5. Można łatwo dodać nowe sekcje i/lub warstwy, zmieniając tylko tablicę configs.
  function initProgressAnimations(configs) {
    configs.forEach(({ trigger, targets }) => {
      const sectionEl = document.querySelector(trigger);
      if (!sectionEl || !targets?.length) return;

      const states = targets.map(() => ({ previousProgress: 0, isActive: false }));

      const observer = new MutationObserver(() => {
        const progress = parseFloat(sectionEl.getAttribute('data-progress'));
        if (isNaN(progress)) return;

        targets.forEach((t, i) => {
          const { selector, activateAt = 50, resetAt = 10 } = t;
          const targetEl = document.querySelector(selector);
          if (!targetEl) return;

          const state = states[i];

          if (progress < resetAt && state.previousProgress > 90) {
            targetEl.classList.remove('active');
            state.isActive = false;
          }

          if (progress >= activateAt && !state.isActive) {
            targetEl.classList.add('active');
            state.isActive = true;
          }

          state.previousProgress = progress;
        });
      });

      observer.observe(sectionEl, { attributes: true, attributeFilter: ['data-progress'] });
    });
  }


/**
 * Nawigacja za pomocą menu lub linków
 **/
  // Przechodzi do wskazanej sekcji (i opcjonalnie podsekcji),
  // jednocześnie inteligentnie ustawiając stan pośrednich sekcji horyzontalnych.
  // Parametry:
  //   @param {string} targetId - ID sekcji docelowej, np. "#section3"
  //   @param {number|null} subsectionIndex - Indeks podsekcji docelowej lub null.
  function handleMenuNavigation(targetId, subsectionIndex = null) {
      const targetSection = document.querySelector(targetId);
      if (!targetSection) {
          console.error("Sekcja docelowa nie została znaleziona:", targetId);
          return;
      }

      const sectionsArray = Array.from(sections());
      const newIndex = sectionsArray.indexOf(targetSection);

      // Ignoruj, jeśli kliknięto w aktywny link lub sekcja nie istnieje
      if (newIndex === -1) return;
      // Sprawdzamy, czy docelowa sekcja I podsekcja są DOKŁADNIE takie same jak obecne.
      // Kończymy działanie TYLKO wtedy, gdy nie ma absolutnie nic do zmiany.
      const hStateCurrent = appState.horizontalStates.get(newIndex);
      if (
          newIndex === appState.currentSection &&
          hStateCurrent &&
          hStateCurrent.currentSubsection === (subsectionIndex ?? 0)
      ) {
          return; 
      }


      // --- KLUCZOWA LOGIKA ---
      // Przejdź przez wszystkie sekcje i ustaw stan horyzontalny
      // w zależności od ich położenia względem nowej, docelowej sekcji.
      sectionsArray.forEach((section, i) => {
          // Sprawdź, czy dana sekcja jest sekcją horyzontalną
          if (appState.horizontalStates.has(i)) {
              const hState = appState.horizontalStates.get(i);
              const wrapper = section.querySelector(".horizontal-wrapper");

              if (i < newIndex) {
                  // Ta sekcja jest PRZED sekcją docelową.
                  // Ustawiamy ją na ostatnią podsekcję, aby umożliwić płynny powrót (scroll-up).
                  hState.currentSubsection = hState.totalSubsections - 1;

              } else if (i > newIndex) {
                  // Ta sekcja jest PO sekcji docelowej.
                  // Resetujemy ją do pierwszej podsekcji, przygotowując na przyszłe przewijanie w dół.
                  hState.currentSubsection = 0;
                  
              } else { // i === newIndex
                  // To jest nasza sekcja docelowa.
                  // Ustawiamy ją na wskazaną podsekcję lub na pierwszą, jeśli nie podano inaczej.
                  hState.currentSubsection = subsectionIndex ?? 0;
              }
              
              // Zastosuj odpowiednią transformację CSS, aby wizualnie odzwierciedlić nowy stan.
              if (wrapper) {
                  wrapper.style.transform = `translateX(-${hState.currentSubsection * 100}vw)`;
              }
          }
      });

      // Zaktualizuj główny stan aplikacji i przesuń kontener pionowo
      appState.currentSection = newIndex;
      container.style.transform = `translateY(-${newIndex * 100}vh)`;

      // Zaktualizuj wizualnie menu
      updateMenu();
      updateSubsectionMenu();
  }







  //  * ************************************
  //  * Inicjalizacja
  //  * ************************************
  function init() {
    initDimensions();
    initParallax();
    initProgressAnimations([
      {
        trigger: '.three2',
        targets: [
          { selector: '.layer1', activateAt: 20, resetAt: 5 },
          { selector: '.layer2', activateAt: 50, resetAt: 10 },
          { selector: '.layer3', activateAt: 80, resetAt: 30 },
        ]
      },
      {
        trigger: '.three',
        targets: [
          { selector: '.facetos-content-dwa', activateAt: 50, resetAt: 10 }
        ]
      }
    ]);

    // Obsługa menu
    document.querySelectorAll('.menu a').forEach(link => {
      link.addEventListener('click', function(e) {

        const rawHref = this.getAttribute('href'); // np. "#section2:2"
        if (!rawHref) return;

        // Jeześli to nie jest "#...", otwieramy w nowej karcie
        if (!rawHref.startsWith('#')) {
          e.preventDefault();
          window.open(rawHref, '_blank');
          return;
        }

        e.preventDefault();  

        const href = decodeURIComponent(rawHref); // <-- to dekoduje %3A na :

        const parts = href.split(':'); // Rozdziel po ":"
        const targetId = parts[0]; // "#section2"
        const subsectionIndex = parts.length > 1 ? parseInt(parts[1], 10) : null;
        handleMenuNavigation(targetId, subsectionIndex);
      });
    });

    // Obsługa linków miedzysekcyjnych
    document.querySelectorAll('a.linka[href^="#"]').forEach(link => { 
      link.addEventListener('click', function(e) {
        e.preventDefault();  
        const rawHref = this.getAttribute('href'); // np. "#section2:2"
        const href = decodeURIComponent(rawHref); // <-- to dekoduje %3A na :

        const parts = href.split(':'); // Rozdziel po ":"
        const targetId = parts[0]; // "#section2"
        const subsectionIndex = parts.length > 1 ? parseInt(parts[1], 10) : null;
        handleMenuNavigation(targetId, subsectionIndex);
      });
    });


    document.querySelectorAll('.sticky-section .sticky-content').forEach(content => {
      content.addEventListener('scroll', function(e) {
          const section = this.closest('.section');
          const scrollTop = this.scrollTop;
          const maxScroll = this.scrollHeight - this.clientHeight;
          const progress = Math.min(100, Math.max(0, (scrollTop / maxScroll) * 100));
          section.setAttribute("data-progress", `${Math.floor(progress)}%`);
      });
    });

    // Event listeners
    document.addEventListener("touchstart", handlePointerStart, { passive: true });
    document.addEventListener("touchmove", handlePointerMove, { passive: false });
    document.addEventListener("touchend", handlePointerEnd, { passive: true });
    document.addEventListener("mousedown", handlePointerStart);
    document.addEventListener("mousemove", handlePointerMove);
    document.addEventListener("mouseup", handlePointerEnd);
    document.addEventListener("mouseleave", handlePointerEnd);
    document.addEventListener("wheel", handleScroll, { passive: false });
    document.addEventListener("keydown", handleKeys);
    document.addEventListener('scroll', handleStickySectionScroll);

    // Usuń event listeners przy czyszczeniu
    // nie jestem pewien czy to działa 
    // window.addEventListener('beforeunload', () => {
    //   window.removeEventListener('scroll', scrollHandler);
    //   document.removeEventListener('wheel', handleScroll);
    // });

    updateMenu(); // Inicjalna aktualizacja menu
    updateSubsectionMenu();
  }
  init();






} // END:  export function initMechanika()